<app-breadcrumb></app-breadcrumb>
<!-- <ng-container *ngIf="fileName">
    <div class="card mb-0">
        <div class="card-body">
            <div class="d-flex align-items-center">
                <div>
                    요청 한 E-Tas 파일이 준비되었습니다
                </div>
                <button type="button" class="btn btn-sm btn-success ml-3"
                    (click)="clickEtasFileDownload()">
                    다운로드
                </button>
            </div>
        </div>
    </div>
</ng-container> -->

<div class="card mb-0">
    <div class="card-body">
        <!-- <div dtg-download-etas-request-list></div> -->
        <div class="text-warning">
            <i class="far fa-bell fa-fw mr-2"></i>
            <span>파일 다운로드 서비스는 개편 작업이 진행중이며 파일이 필요하신 경우 크레스트인볼브먼트 영업팀으로 문의하시길 바랍니다</span>
        </div>
        <div class="text-warning">
            <i class="fas fa-phone fa-fw mr-2"></i>
            <a href="tel:070-8652-0227" class="text-warning">070-8652-0227</a>
        </div>
    </div>
</div>